<template lang="pug">
  section.mt-140.md-mt-194.font-sabon.text-center.overflow-x-hidden(v-if="canRender")
    header.hidden.md-block.px-20.mb-75
      h6.text-14 Further Reading
    section.md-flex.justify-center.items-stretch.md-px-10
      //- circles
      //- md: expanding circles on single row
      .discover__topic.relative.pb-ar-topic-mbl.md-pb-0.mb-90.md-mb-0.md-w-1x4.lg-w-1x6.md-hover-w-4x6.md-mb-0.flex.items-center.justify-center.md-min-h-480.lg-min-h-640(v-for="topic in topics", style="transition:width 600ms")
        //- header (above circle)
        h3.absolute.top-0.left-0.w-full.transly_-100.pb-12.capitalize.text-14 {{topic}}
        //- circle svg
        svg-ellipse.absolute.top-0.w-130pct.md-w-full.h-full
        //- articles
        article.absolute.inset-0.flex.items-center.justify-center(v-for="(item, i) in grp(topic)", :class="{'opacity-0 pointer-events-none': !isVisible(i, topic)}", :style="{transition: !isVisible(i, topic) ? 'opacity 200ms' : 'opacity 400ms 100ms'}")
          article-link.block.w-3x5.md-w-3x4.md-max-w-22vw.hover-text-app-text.hover-scale-figure(:to="rt(item)")
            figure.pt-15.md-pt-0
              resp-img(:lazy="true", :src="img(item).url", :alt="img(item).alt", v-if="img(item)", imgClass="max-h-40vw w-auto mx-auto md-max-h-none")
            h4.mt-15.leading-sm.text-14.hover-text-app-text(v-html="(item.article.acf && item.article.acf.title_on_index) || item.article.post_title")
        //- (categories - change active article on hover)
        nav.discover__topic__cats.hidden.md-flex.absolute.inset-0.items-center.justify-center.text-16.pointer-events-none(v-if="grp(topic).length > 1")
          //- item links
          .block.flex-1.text-center.whitespace-no-wrap(v-for="(item, i) in grp(topic)", v-if="subTopic(item, topic)" )
            router-link.pointer-events-auto.inline-block.p-4(@mouseenter.native="show(i, topic)", :class="{'text-app-accent': isVisible(i, topic)}", :to="rt(item)") {{ subTopic(item, topic) }}
        //- (mobile arrows)
        nav.absolute.inset-0.flex.justify-between.pointer-events-none.md-hidden(v-if="grp(topic).length > 1")
          button.px-15.pointer-events-auto(@click="next(-1, topic)", aria-label="Previous Article")
            icon-arrow(style="transform:rotate(180deg)")
          button.px-15.pointer-events-auto(@click="next(1, topic)", aria-label="Next Article")
            icon-arrow
</template>

<script>
import svgEllipse from '@/components/Icons/SVG-Ellipse'
import RespImg from '@/components/RespImg'
import ArticleLink from '@/components/ArticleLink'
import IconArrow from '@/components/Icons/Arrow'
export default {
  name: 'FurtherReading',
  props: ['doc'], // doc.acf
  data () {
    return {
      topics: ['people', 'space', 'context'],
      peopleActive: 0,
      spaceActive: 0,
      contextActive: 0
    }
  },
  computed: {
    canRender () {
      const enabled = this.doc && this.doc.discover__status === 'enabled'
      if (!enabled) return false
      // each category must have (at least) 1 article
      const keys = Object.keys(this.doc).filter(key => key.indexOf('discover__articles') === 0)
      const matches = keys.filter(key => this.doc[key] && this.doc[key].length > 0)
      return matches.length === 3
    }
  },
  methods: {
    rt (itm) {
      return { name: 'article', params: { slug: itm.article.post_name } }
    },
    title (article) {
      return (article.acf && article.acf.title_on_index) || article.post_title
    },
    img (item) {
      return item.image || item.article.featured_image
    },
    isVisible (i, topic) {
      return i === this[topic + 'Active']
    },
    show (i, topic) {
      this[topic + 'Active'] = i
    },
    grp (topic) {
      return this.doc['discover__articles_' + topic] || []
    },
    subTopic (item, topic) {
      let cat = item.article.categories || []
      cat = cat.find(c => c.parent === topic) || cat[0]
      return cat && cat.slug !== topic && cat.name
    },
    next (dir, topic) {
      const actv = this[topic + 'Active']
      const itms = this.grp(topic)
      this[topic + 'Active'] = actv + dir < 0 ? itms.length - 1 : actv + dir >= itms.length ? 0 : actv + dir
    }
  },
  components: { svgEllipse, RespImg, IconArrow, ArticleLink }
}
</script>

<style scoped>
.discover__topic .discover__topic__cats{visibility: hidden}
/* topic hover > show categories */
@media (hover:hover) {
  .discover__topic{
    & .discover__topic__cats{visibility: visible; opacity:0; transition:opacity 0s 100ms;}
    &:hover .discover__topic__cats{ opacity:1 };
  }
}
</style>
